<template>
    <span v-if="productConfiguratorTitle && product_configurator_id">{{ $t(productConfiguratorTitle)}}</span>
</template>

<script>
export default {
    name: "ProductConfiguratorTitle",
    props: ['product_configurator_id', 'product_configurators'],

    data() {
        return {
            productConfiguratorTitle: 'tempLED',
        }
    },

    created() {
        this.setProductConfiguratorTitle();

    },


    methods: {
        getProductConfigurators() {
            axios.get('/api/product_configurator_by_id/' + this.product_configurator_id)
                .then(response => {
                    this.productConfiguratorTitle = response.data.data.title;
                }).catch(error => {
                this.loadingError = error.response;
            });
        },

        setProductConfiguratorTitle() {
            if (Array.isArray(this.product_configurators) && this.product_configurators.length) {
                this.productConfiguratorTitle = this.product_configurators.find(el => el.id === this.product_configurator_id).title;
            } else {
                this.getProductConfigurators();
            }
        },

    },
}
</script>

<style scoped>

</style>
